import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import {
  Block as BlockIcon,
  Home as HomeIcon,
} from '@mui/icons-material';

const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4, md: 6 },
          textAlign: 'center',
          borderTop: 4,
          borderColor: 'error.main',
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <BlockIcon sx={{ fontSize: 48, color: 'white' }} />
          </Box>
        </Box>

        {/* Title */}
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 'bold', color: 'text.primary' }}
        >
          Access Denied
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, fontSize: { xs: '0.95rem', sm: '1rem' } }}
        >
          You don't have permission to view this page.
          Please contact your administrator if you believe this is an error.
        </Typography>

        {/* Action */}
        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
        >
          Go to Home
        </Button>
      </Paper>
    </Container>
  );
};

export default AccessDeniedPage;
